export default class {
    constructor ($compile, $) {
        this.$compile = $compile;
        this.$ = $;
    }

    getResponsiveOption (getRowScope) {
        const { $compile, $ } = this;
        return {
            responsive: {
                details: {
                    renderer: (api, rowIdx) => {
                        const $scope = getRowScope(rowIdx);
                        const data = api.cells(rowIdx, ':hidden').eq(0).map((cell) => {
                            const header = $(api.column(cell.column).header());
                            let cn = $(api.cell(cell).nodes()).attr('class');
                            if (cn === undefined) {
                                cn = '';
                            }
                            cn = cn.replace('hidden', '');
                            const html = $(api.cell(cell).nodes()).html().replace('ng-non-bindable=""', '');
                            return `
                                <div class="row ${header.attr('class').replace('hidden', '')}">
                                    <div class="cell-label">${header.text()}</div>
                                    <div class="cell-value${cn}">${html}</div>
                                </div>
                            `;
                        }).toArray().join('');
                        const returnVal = data ? $compile($('<div />').append(data))($scope) : false;
                        $scope.$digest();
                        return returnVal;
                    }
                }
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/services/datatable/index.js